import * as React from "react";

import ClassNames from "classnames";
import Styles from "./Typography.module.css";

export interface Props {
  children: any;
  className?: string;
  display?: "default" | "light";
  id?: string;
  noBottomMargin?: boolean;
  noTopMargin?: boolean;
  body?: "default" | "small" | "smallCaps";
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
}

const Typography: React.FC<Props> = props => {
  const {
    id,
    children,
    className,
    display = "default",
    noBottomMargin = false,
    noTopMargin = false,
    body = "default",
    variant = "p"
  } = props;

  const Component = variant || "span";

  return (
    <Component
      id={id}
      className={
        ClassNames({
          [Styles[variant]]: true,
          [Styles[body]]: body !== "default",
          [Styles.light]: display === "light",
          [Styles.noBottomMargin]: noBottomMargin,
          [Styles.noTopMargin]: noTopMargin,
          [className]: className
        }) || undefined
      }
    >
      {children}
    </Component>
  );
};

export default Typography;
